export const ERROR_MSG = {
  uploadFileErrorMsg: "Upload file to blob is failed. Please try again",
  sasURLErrorMsg: "Generating sasToken is failed. Please try again",
  maliciousFileStatusError: "Malicious file Status api Failed",
  maliciousEndResult: "A malicious file has been identified during the file scan",
  sasTokenError: "SAS Token Error",
};

export const SCAN_RESULT_TYPE = {
  noThreatsFound: 'No threats found',
  malicious: 'Malicious',
};

export const POLLING_API_URL = 'platform/fileScanLogEntry';

export const POLLING_DURATION = 2000;

export const FILE_SCAN_URLS = {
  pollingUrl: 'fileScanLogEntry',
  sasTokenUrl: 'getSASTokenAndCreateUploadRow',
};

export const SAS_URL = 'platform/getSASTokenAndCreateUploadRow';

export const ANTI_VIRUS_SCAN_STATUS =
  'Please wait. The file(s) is being scanned...';